<template>
    <div class="mt-1">
        <BaseButton
            size="xs"
            @click="startResendProcess(data.mailId)">
            {{ $t('mails.resendMail') }}
        </BaseButton>
        <ResendMailModal
            v-model="isMailResendModalOpen"
            :mail="mailToResend"
            @resent="reload" />
    </div>
</template>

<script setup>
import {useMailStore} from "@/store/mail"
import {tableStores} from "@/store/tableModules"

const route = useRoute()
const {t: $t} = useI18n()
const mailStore = useMailStore()

defineProps({
    data: {
        type: Object,
        required: true
    }
})

const isMailResendModalOpen = ref(false)
const mailToResend = ref(null)

function startResendProcess(mailId) {
    mailToResend.value = {id: mailId}
    isMailResendModalOpen.value = true
}

function reload() {
    if (route.name === 'service-basicData-mails') {
        tableStores.mails().fetchData(true)
    } else if (route.name === 'service-basicData-mails-id-mailBaseData') {
        mailStore.fetchMailData(route.params.id)
    }
}
</script>